// extracted by mini-css-extract-plugin
export default {"textArea":"defaultTextArea_textArea__T2JEu"};